module.exports = __webpack_public_path__ + "img/consult_info8.122715e2.png";